import { render, staticRenderFns } from "./DeviceParamsPanel.vue?vue&type=template&id=7884d8d4&scoped=true"
import script from "./DeviceParamsPanel.vue?vue&type=script&lang=js"
export * from "./DeviceParamsPanel.vue?vue&type=script&lang=js"
import style0 from "./DeviceParamsPanel.vue?vue&type=style&index=0&id=7884d8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884d8d4",
  null
  
)

export default component.exports